import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ServicoAutenticacao } from '../auth/servico-autenticacao';

export const guardaAutenticado: CanActivateFn = () => {
  const autenticacao = inject(ServicoAutenticacao);
  const roteador = inject(Router);

  if (!autenticacao.possuiToken) {
    return roteador.parseUrl('/login');
  }

  if (autenticacao.usuarioLogado) {
    return autenticacao.usuarioLogado.perfil === 'SERVIDOR'
      ? roteador.parseUrl('/servidor')
      : true;
  }

  return autenticacao.carregarSessao().pipe(
    map(usuario => usuario.perfil === 'SERVIDOR' ? roteador.parseUrl('/servidor') : true),
    catchError(() => {
      autenticacao.sair();
      return of(roteador.parseUrl('/login'));
    })
  );
};

export const guardaAdministradorGlobal: CanActivateFn = () => {
  const autenticacao = inject(ServicoAutenticacao);
  const roteador = inject(Router);

  const validarPerfil = () => autenticacao.usuarioLogado?.perfil === 'ADMIN_GLOBAL'
    ? true
    : roteador.parseUrl('/menu');

  if (!autenticacao.possuiToken) {
    return roteador.parseUrl('/login');
  }

  if (autenticacao.usuarioLogado) {
    return validarPerfil();
  }

  return autenticacao.carregarSessao().pipe(
    map(validarPerfil),
    catchError(() => {
      autenticacao.sair();
      return of(roteador.parseUrl('/login'));
    })
  );
};

export const guardaServidor: CanActivateFn = () => {
  const autenticacao = inject(ServicoAutenticacao);
  const roteador = inject(Router);

  const validarPerfil = () => autenticacao.usuarioLogado?.perfil === 'SERVIDOR'
    ? true
    : roteador.parseUrl('/menu');

  if (!autenticacao.possuiToken) {
    return roteador.parseUrl('/servidor/login');
  }

  if (autenticacao.usuarioLogado) {
    return validarPerfil();
  }

  return autenticacao.carregarSessao().pipe(
    map(validarPerfil),
    catchError(() => {
      autenticacao.sair();
      return of(roteador.parseUrl('/servidor/login'));
    })
  );
};
